import { grey300 } from 'ext-ui/style/colors'
import { flyout_headerVSpacing, spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${flyout_headerVSpacing};

  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${spacing(2)};
  }

  .split-button {
    &.selected {
      background-color: ${grey300};
    }
  }
`

export const skeletonTitle = css`
  margin-bottom: ${spacing(5)};
  width: 50%;
  height: 24px;
`

export const skeletonCategory = css`
  width: 25%;
  height: 20px;
`

export const skeletonLabel = css`
  width: 66%;
  height: 16px;
`
